import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { giraffeRoot } from '@/lib/giraffePaths';

/**
 * GiraffeCountries (deprecated as of Wave 3A.5).
 *
 * The Countries view is now a tab inside the Giraffe root four-tab layout
 * (ACTIVE TRIPS / COUNTRIES / MEMOIRS / ARCHIVE). The page-level component
 * is kept only as a redirect so any external links or bookmarks pointing
 * at /giraffe/countries land on the right tab.
 *
 * The actual rendering and edit logic now lives in
 * src/components/giraffe/GiraffeCountriesTab.js.
 */
export default function GiraffeCountries() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`${giraffeRoot()}?tab=countries`, { replace: true });
  }, [navigate]);

  return null;
}
